import { iconFileUpload } from "assets/icons"
import { Button } from "components/Button"
import { InputHTMLAttributes, useRef } from "react"
import { ErrorText, PdfInput, PdfInputWrapper } from "./styles"

export interface InputPdfProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean,
  errorMessage?: string,
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const InputPdf: React.FC<InputPdfProps> = ({
  error,
  errorMessage,
  ...props
}) => {
  const fileInput = useRef<any>(null);

  const onButtonClickHandler = () => {
    fileInput.current.click();
  }

  return (
    <PdfInputWrapper>
      <PdfInput
        type="file"
        accept="application/pdf"
        ref={fileInput}
        {...props}
      />
      <Button
        label="Selecionar PDF"
        typeBtn="outline"
        size="large"
        type="button"
        icon={iconFileUpload}
        onClick={onButtonClickHandler}
      />
      
      {error ? <ErrorText>{errorMessage}</ErrorText> : ""}
    </PdfInputWrapper>
  )
} 